.image-grid {
  --_row-height: var(--row-height, 140px);
  --_gap: var(--gap, 0.5rem);

  display: flex;
  flex-wrap: wrap;
  gap: var(--_gap);
  list-style: none;
  margin: 0;
  padding: 0;

  li {
    height: var(--_row-height);
    overflow: hidden;

    img {
      max-height: 100%;
      height: 100%;
      min-width: 100%;
      width: auto;
      object-fit: cover;
    }
  }
}
